<template>
  <div class="transitions-container">
    <md-menu md-size="auto" md-align-trigger :md-active.sync="isListVisible">
      <md-button md-menu-trigger :disabled="disabled || creatingCustomerGroup">
        <md-icon v-if="!creatingCustomerGroup">open_in_new</md-icon>
        <spinner v-else :diameter="14" :stroke="3" />
        <span
          :style="{
            textDecoration: disabled ? 'line-through' : undefined,
          }"
          >{{ buttonText }}
        </span>
      </md-button>
      <md-menu-content style="z-index:10000">
        <md-menu-item
          class="item"
          v-for="t of userTransitions"
          :key="t.text"
          :transition="t"
          @click="$emit('transition', t)"
        >
          <div>
            <md-avatar class="avatar">
              <img :src="t.imageUrl" />
            </md-avatar>
            {{ t.text }}
          </div>
        </md-menu-item>
      </md-menu-content>
    </md-menu>

    <gl-switch
      :value="immediate"
      @input="$emit('update:immediate', $event)"
      :disabled="disabled"
      :primary="!disabled"
    >
      即時
    </gl-switch>
  </div>
</template>

<script>
import Spinner from '@/components/Spinner.vue'

const queryTransitions = [
  {
    menuCode: 'pudding-s',
    option: 'rank',
    transition({ destination, queryId, override }) {
      if (!override.option) {
        override.option = {}
      }
      override.option.customerSegment = 'rank'
      override.option.evaluations = [
        'customer_count',
        'qty',
        'amount',
        'receipt_count',
      ]

      return `query-${destination}?reference=${queryId}&override=${JSON.stringify(
        override,
      )}`
    },
  },
  {
    menuCode: 'pudding-s',
    option: 'pfv',
    transition({ destination, queryId, override }) {
      if (!override.option) {
        override.option = {}
      }
      override.option.customerSegment = 'pfv'
      override.option.evaluations = [
        'customer_count',
        'qty',
        'amount',
        'receipt_count',
      ]

      return `query-${destination}?reference=${queryId}&override=${JSON.stringify(
        override,
      )}`
    },
  },
  {
    menuCode: 'pudding-s',
    option: 'age',
    transition({ destination, queryId, override }) {
      if (!override.option) {
        override.option = {}
      }
      override.option.customerSegment = 'age'
      override.option.evaluations = [
        'customer_count',
        'qty',
        'amount',
        'receipt_count',
      ]

      return `query-${destination}?reference=${queryId}&override=${JSON.stringify(
        override,
      )}`
    },
  },
  {
    menuCode: 'monkey-s',
    transition({ destination, queryId, override }) {
      if (!override.option) {
        override.option = {}
      }
      override.option.evaluations = [
        'amount',
        'qty',
        'receipt_count',
        'customer_count',
        'amount_per_qty',
        'qty_per_receipt',
        'amount_per_receipt',
        'receipt_per_customer',
        'qty_per_customer',
        'amount_per_customer',
      ]

      return `query-${destination}?reference=${queryId}&override=${JSON.stringify(
        override,
      )}`
    },
  },
  {
    menuCode: 'pudding-i',
    option: 'rank',
    transition({ destination, queryId, override }) {
      if (!override.option) {
        override.option = {}
      }
      override.option.customerSegment = 'rank'
      override.option.evaluations = [
        'customer_count',
        'qty',
        'amount',
        'receipt_count',
      ]

      return `query-${destination}?reference=${queryId}&override=${JSON.stringify(
        override,
      )}`
    },
  },
  {
    menuCode: 'pudding-i',
    option: 'pfv',
    transition({ destination, queryId, override }) {
      if (!override.option) {
        override.option = {}
      }
      override.option.customerSegment = 'pfv'
      override.option.evaluations = [
        'customer_count',
        'qty',
        'amount',
        'receipt_count',
      ]

      return `query-${destination}?reference=${queryId}&override=${JSON.stringify(
        override,
      )}`
    },
  },
  {
    menuCode: 'pudding-i',
    option: 'age',
    transition({ destination, queryId, override }) {
      if (!override.option) {
        override.option = {}
      }
      override.option.customerSegment = 'age'
      override.option.evaluations = [
        'customer_count',
        'qty',
        'amount',
        'receipt_count',
      ]

      return `query-${destination}?reference=${queryId}&override=${JSON.stringify(
        override,
      )}`
    },
  },
  {
    menuCode: 'monkey-i',
    transition({ destination, queryId, override }) {
      if (!override.option) {
        override.option = {}
      }
      override.option.evaluations = [
        'amount',
        'qty',
        'receipt_count',
        'customer_count',
        'amount_per_qty',
        'qty_per_receipt',
        'amount_per_receipt',
        'receipt_per_customer',
        'qty_per_customer',
        'amount_per_customer',
      ]

      return `query-${destination}?reference=${queryId}&override=${JSON.stringify(
        override,
      )}`
    },
  },
  {
    menuCode: 'monkey-c',
    option: 'rank',
    transition({ destination, queryId, override }) {
      if (!override.option) {
        override.option = {}
      }
      override.option.customerSegment = 'rank'
      override.option.evaluations = [
        'amount',
        'qty',
        'receipt_count',
        'customer_count',
        'amount_per_qty',
        'qty_per_receipt',
        'amount_per_receipt',
        'receipt_per_customer',
        'qty_per_customer',
        'amount_per_customer',
      ]

      return `query-${destination}?reference=${queryId}&override=${JSON.stringify(
        override,
      )}`
    },
  },
  {
    menuCode: 'monkey-c',
    option: 'pfv',
    transition({ destination, queryId, override }) {
      if (!override.option) {
        override.option = {}
      }
      override.option.customerSegment = 'pfv'
      override.option.evaluations = [
        'amount',
        'qty',
        'receipt_count',
        'customer_count',
        'amount_per_qty',
        'qty_per_receipt',
        'amount_per_receipt',
        'receipt_per_customer',
        'qty_per_customer',
        'amount_per_customer',
      ]

      return `query-${destination}?reference=${queryId}&override=${JSON.stringify(
        override,
      )}`
    },
  },

  {
    menuCode: 'monkey-c',
    option: 'age',
    transition({ destination, queryId, override }) {
      if (!override.option) {
        override.option = {}
      }
      override.option.customerSegment = 'age'
      override.option.evaluations = [
        'amount',
        'qty',
        'receipt_count',
        'customer_count',
        'amount_per_qty',
        'qty_per_receipt',
        'amount_per_receipt',
        'receipt_per_customer',
        'qty_per_customer',
        'amount_per_customer',
      ]

      return `query-${destination}?reference=${queryId}&override=${JSON.stringify(
        override,
      )}`
    },
  },

  {
    menuCode: 'monkey-d',
    transition({ destination, queryId, override }) {
      if (!override.option) {
        override.option = {}
      }
      override.option.evaluations = [
        'amount',
        'qty',
        'receipt_count',
        'amount_per_receipt',
        'qty_per_receipt',
        'amount_per_qty',
      ]

      return `query-${destination}?reference=${queryId}&override=${JSON.stringify(
        override,
      )}`
    },
  },
]

export default {
  components: { Spinner },
  props: {
    queryId: {
      type: String,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    creatingCustomerGroup: {
      type: Boolean,
      default: false,
    },
    immediate: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      /**
       * 無効となっている遷移先一覧
       */
      blockRoutes: [],
      /**
       * 遷移先一覧の表示状態管理
       */
      isListVisible: false,
      /**
       * 画面遷移定義
       *
       * {
       *   menuCode: 遷移先のメニューコード。メニュー画面でロードするメニュー一覧のメニューコードと一致させます。
       *   option: 追加情報（顧客セグメントの「ランク」とか）
       *   text: 表示テキスト。これもメニューと一致させています。
       *   transition: 遷移先画面のURLを返す関数。
       * }
       */
      // queryTransitions: ,
    }
  },
  computed: {
    /**
     * 画面遷移一覧
     *
     * ログインユーザーの権限で閲覧できるメニューであり、遷移不可リストに
     * 載っていないメニューに絞る。
     */
    userTransitions() {
      const menuCodesAllowed = new Set(
        this.$store.state.menus.map(m => m.menuCode),
      )
      const menusAllowed = queryTransitions.filter(t =>
        menuCodesAllowed.has(t.menuCode),
      )
      const menusNotBlocked = menusAllowed.filter(
        t =>
          !this.blockRoutes.includes(
            t.menuCode + (t.option ? `/${t.option}` : ''),
          ),
      )
      return menusNotBlocked
    },
    /**
     * ボタンテキスト
     *
     * 画面遷移時、必ず顧客グループ作成処理が行われる。ちょっと時間がかかるので、
     * 押下時にはテキストを変える。
     */
    buttonText() {
      return this.creatingCustomerGroup
        ? '顧客グループを作成しています'
        : '他の分析へ'
    },
  },
  watch: {
    queryId: {
      immediate: true,
      async handler(queryId) {
        if (queryId) {
          // Computedとしていないのは、一覧取得が非同期処理なので。
          // TODO でも、画面表示中に一覧って更新される？変わらないのならコンポーネントロード時にでも
          //      mountedとかで取得してセットした方がいいのでは？
          this.blockRoutes = await this.$longQuery.fetchBlockRoute(queryId)
        }
      },
    },
  },
  created() {
    // 遷移先一覧に表示する要素の表示名を設定する
    // 画面+顧客セグメントの組み合わせもあるのでここでStoreからラベル等を取得する
    for (const t of queryTransitions) {
      const menu = this.$store.state.menus.find(m => m.menuCode === t.menuCode)
      if (!menu) {
        continue
      }

      t.text = menu.menuLongName

      if (t.option) {
        t.text = `${t.text}（${
          this.$store.state.labels.customerSegment[t.option]
        }）`
      }

      t.imageUrl = menu.imageUrl
    }
  },
}
</script>

<style lang="scss" scoped>
.transitions-container {
  display: flex;
  justify-content: center;
  align-items: center;
}

.item {
  cursor: pointer;
}

.avatar {
  margin-right: var(--spacing-small);
  img {
    object-fit: cover;
  }
}

.md-menu-content {
  max-width: 100%;
}
</style>
